import { createSlice } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';

type DictTransfer = Record<string, any>;

const initialState: DictTransfer = {};

export const transferSlice = createSlice({
    name: 'transfer',
    initialState,
    reducers: {
        addTransfer: (state, action) => {
            state[action.payload.key] = action.payload.value;
        },

        removeTransfer: (state, action) => {
            if (!action.payload) {
                return cloneDeep(initialState);
            }

            delete state[action.payload.key];
        },
    },
});

export const { addTransfer, removeTransfer } = transferSlice.actions;

export default transferSlice.reducer;
